import $ from 'jquery'
import PaymentPage from './PaymentPage'

export const waitForConvert = (totalTimes) => {
  totalTimes--;
  if (totalTimes < 0 || window.adyen_card_enabled !== undefined) {
    activatePaymentPage();
  } else {
    setTimeout(waitForConvert, 100, totalTimes);
  }
}

export const activatePaymentPage = () => {
  var $paymentOptionsForm = $('#payment-options-form');
  if ($paymentOptionsForm.length) {
    const paymentPage = new PaymentPage($paymentOptionsForm);
    paymentPage.orchestratePaymentOptions();
  }
}

export const paymentsWaitForConvert = () => {
  const valString = $('meta[name=payments_wait_for_convert]').attr('content');
  return valString ? parseInt(valString) : 0;
} 

$(async function () {
  waitForConvert(paymentsWaitForConvert());
});
